import { SearchQuestionPage } from './SearchQuestionPage';
export default SearchQuestionPage;
